var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('header-bar',{key:_vm.$route.fullPath}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_vm._t("default")],2),_c('div',{staticClass:"col-md-3"},[_c('side-bar')],1)]),_c('footer-bar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }